export const PHONE = "+919458233787";
export const PHONE_LABEL = "+91 94582 33787";
export const WHATSAPP =
  "https://wa.me/919458233787?text=Namaste%20Pandit%20Ajay%20Sagar%20Shukla%20Ji%2C%20I%20would%20like%20to%20consult%20for%20Vedic%20Astrology%20%2F%20Yagya.";
export const FACEBOOK = "https://www.facebook.com/share/g/1Fp2EpjpuJ/?mibextid=wwXIfr";
export const MAPS = "https://maps.app.goo.gl/hudyqafQc3wigCGB9?g_st=ic";

export const scrollToId = (id) => {
  const el = document.getElementById(id);
  if (!el) return;
  if (window.__lenis) window.__lenis.scrollTo(el, { offset: -72 });
  else el.scrollIntoView({ behavior: "smooth" });
};

export const EASE = [0.22, 1, 0.36, 1];
